module.exports = __webpack_public_path__ + "img/social-distancing.70295f69.jpg";